import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import useFetch from 'hooks/useFetch';
import useLocation from 'hooks/useLocation';
import useTracking from 'hooks/useTracking';
import { EMAIL_CODE_VERIFICATION_URL, USERS_VERIFICATION_URL } from 'constants/routes';
import { ClickableElement } from 'constants/tracking/clickable-elements';
import { Screen } from 'constants/tracking/screens';
import { VerificationMethods } from 'constants/verification';
import { dismissVerificationPrompt, getVerificationPrompt } from 'data/api';
import { clickEvent } from 'libs/common/event-tracker/events';
import { getUser } from 'state/session/selectors';
import { EmailCodeView } from 'state/verifications/constants';
import { getEmailCodeView } from 'state/verifications/selectors';
const screenByEmailCodeView = {
  [EmailCodeView.EnterCode]: Screen.MandatoryEmailVerificationEnterCode,
  [EmailCodeView.NotReceiveEmail]: Screen.MandatoryEmailVerificationResendCode,
  [EmailCodeView.Success]: Screen.MandatoryEmailVerificationSuccess
};
export const useEmailCodeTest = () => {
  const user = useSelector(getUser);
  const view = useSelector(getEmailCodeView);
  const {
    track
  } = useTracking();
  const {
    fetch: fetchPrompts,
    data: prompts,
    error,
    isLoading: isLoadingPrompts
  } = useFetch(getVerificationPrompt);
  const {
    relativeUrl
  } = useLocation();
  const isEmailCodeMethod = prompts === null || prompts === void 0 ? void 0 : prompts.prompt.methods.includes(VerificationMethods.EmailCode);
  const isInVerificationFlow = relativeUrl === USERS_VERIFICATION_URL || relativeUrl === EMAIL_CODE_VERIFICATION_URL;
  useEffect(() => {
    if (!isInVerificationFlow) return;
    if (!(user !== null && user !== void 0 && user.id)) return;
    fetchPrompts(user.id);
  }, [user, isInVerificationFlow, fetchPrompts]);

  const trackEmailCodeSkipEvent = () => {
    if (error) return;
    if (!isEmailCodeMethod) return;
    if (prompts !== null && prompts !== void 0 && prompts.prompt.mandatory) return;
    track(clickEvent({
      screen: Screen.MandatoryEmailVerificationStart,
      target: ClickableElement.Skip
    }));
  };

  const handleDismissVerificationPrompt = async () => {
    if (!(user !== null && user !== void 0 && user.id)) return;
    if (error) return;
    if (!isEmailCodeMethod) return;
    if (prompts !== null && prompts !== void 0 && prompts.prompt.mandatory) return;
    await dismissVerificationPrompt(user.id);
  };

  const trackLogoutEvent = () => {
    if (!isEmailCodeMethod) return;
    const eventData = {
      screen: Screen.MandatoryEmailVerificationStart,
      target: ClickableElement.SessionsLogOut
    };

    if (relativeUrl === EMAIL_CODE_VERIFICATION_URL) {
      eventData.screen = screenByEmailCodeView[view];
    }

    track(clickEvent(eventData));
  };

  return {
    trackLogoutEvent,
    trackEmailCodeSkipEvent,
    handleDismissVerificationPrompt,
    isLoadingPrompts
  };
};